var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-text-field',{attrs:{"label":_vm.label,"required":_vm.required,"disabled":_vm.disabled,"rules":_vm.rules,"readonly":_vm.readonly},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }